export default function Terms() {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Terms of Service</h1>

      <p>Last updated: June 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using this app, you agree to these Terms of Service.
      </p>

      <h2>2. App Purpose</h2>
      <p>
        This app provides generated chord suggestions based on moods,
        feelings, and creative prompts for music production purposes.
      </p>

      <h2>3. Creative Use</h2>
      <p>
        Generated chords are suggestions only. Results may vary and are
        intended for creative inspiration.
      </p>

      <h2>4. Pro Features</h2>
      <p>
        Paid subscriptions unlock additional features and generation limits.
        Features may change as the app develops.
      </p>

      <h2>5. Acceptable Use</h2>
      <p>
        You agree not to abuse, exploit, reverse engineer, or disrupt the app.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        This app is provided "as is" without guarantees of uninterrupted
        service or specific creative outcomes.
      </p>

      <h2>7. Changes</h2>
      <p>
        We may update these Terms from time to time.
      </p>

      <h2>8. Contact</h2>
      <p>
        Questions? Contact us through the app or social channels.
      </p>
    </div>
  );
}
